export default __webpack_public_path__ + "static/media/fusion.9aa94e2b.png";